import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import Anchor from '../Anchor';

const StyledHeadline = styled.div`
  color: ${({ theme }) => theme.colors?.white};
  font-family: ${({ theme }) => theme.fonts?.primary};
  font-size: ${({ theme }) => theme.sizes?.body1};
  margin: 0;
  text-align: center;
`;

const StyledAnchor = styled(Anchor)`
  && {
    color: ${({ theme }) => theme.colors?.white};
    font-family: ${({ theme }) => theme.fonts?.primary};
    font-size: ${({ theme }) => theme.sizes?.body1};
  }
`;

const StatusLinkContainer = styled.div`
  margin-top: 16px;
`;

const Title = ({ currentYear }) => (
  <div>
    <StyledHeadline>
      Fashion Jobs | Fashion News | Business Intelligence
      <br />
      Part of the FashionUnited Group |
      {' '}
      <StyledAnchor
        styled
        href="https://fashionunited.info/"
        target="_blank"
        rel="noopener noreferrer"
        hoverUnderline
      >
        FashionUnited.info © FashionUnited
        {' '}
        {currentYear}
      </StyledAnchor>
      <StatusLinkContainer>
        <StyledAnchor
          styled
          target="_blank"
          rel="noopener noreferrer"
          href="https://status.fashionunited.com"
          hoverUnderline
        >
          See platform status
        </StyledAnchor>
      </StatusLinkContainer>
    </StyledHeadline>
  </div>
);

Title.propTypes = {
  currentYear: PropTypes.number.isRequired,
};

const StyledMiniFooter = styled.section`
  max-width: 1392px;
  padding: 48px 0 0;
  margin: 0 auto;
`;

const MiniFooter = ({ currentYear }) => (
  <StyledMiniFooter>
    <Title currentYear={currentYear} />
  </StyledMiniFooter>
);

MiniFooter.propTypes = {
  currentYear: PropTypes.number.isRequired,
};

export default MiniFooter;
